export enum UserTypeEnum {
  Cliente = "Cliente",
  Officer = "Officer",
  Administrator = "Administrator",
  ClienteMigalhas = "ClienteMigalhas",
  ClientePan = "ClientePan",
  Lawyer = "Lawyer",
  ClienteAcordoCerto = "ClienteAcordoCerto",
  Sistema = "Sistema",
  Integracoes = "Integracoes",
  Cartorio = "Cartorio",
  DigitalCertificate = "DigitalCertificate"
}

export const CognitoUserTypeMap = new Map<UserTypeEnum, string>([
  [UserTypeEnum.Cliente, "client"],
  [UserTypeEnum.Officer, "officer"],
  [UserTypeEnum.Administrator, "admin"],
  [UserTypeEnum.ClienteMigalhas, "clientMigalhas"],
  [UserTypeEnum.ClientePan, "clientPan"],
  [UserTypeEnum.Lawyer, "legal"],
  [UserTypeEnum.ClienteAcordoCerto, "clientAcordoCerto"],
  [UserTypeEnum.Sistema, "system"],
  [UserTypeEnum.Integracoes, "integrations"],
  [UserTypeEnum.Cartorio, "cartorio"],
  [UserTypeEnum.DigitalCertificate, "DigitalCertificate"]
]);
